import { de, en, es, fr, nl, pt } from './locales';

export const takeLocales = (cultureCode: string = 'en') => {
  if (cultureCode.startsWith('es')) {
    return es.default;
  }
  if (cultureCode.startsWith('pt')) {
    return pt.default;
  }
  if (cultureCode.startsWith('fr')) {
    return fr.default;
  }
  if (cultureCode.startsWith('en')) {
    return en.default;
  }
  if (cultureCode.startsWith('de')) {
    return de.default;
  }
  if (cultureCode.startsWith('nl')) {
    return nl.default;
  }

  return en.default;
};
